export default __webpack_public_path__ + "assets/cerpe-component.ee441ce1.svg";